import { Link } from '@atoms/Link/Link';
import { Fragment } from 'react';
import { ChevronRight } from 'react-bootstrap-icons';

export interface NavigationLinkObject {
  level: number;
  title: string;
  href?: string;
}

export interface NavigationLinkProps {
  linkObjectArrays: NavigationLinkObject[];
}

const isLastElement = (index: number, array: NavigationLinkObject[]) => {
  return index === array.length - 1;
};

export const NavigationLink: React.FC<NavigationLinkProps> = ({
  linkObjectArrays,
}) => {
  return (
    <div className="flex items-center gap-2 text-[15px]">
      {linkObjectArrays.map((linkObject, i) => (
        <Fragment key={linkObject.title + i}>
          {isLastElement(i, linkObjectArrays) ? (
            <p>{linkObject.title}</p>
          ) : (
            <Link
              className={`text-action-link hover:text-action-link-hover font-semibold underline`}
              href={linkObject.href}
              linkType="inline"
            >
              <p>{linkObject.title}</p>
            </Link>
          )}
          {isLastElement(i, linkObjectArrays) ? null : (
            <ChevronRight className="text-action-link w-3" />
          )}
        </Fragment>
      ))}
    </div>
  );
};

NavigationLink.displayName = 'Link';
